"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function () {
  return new SimpleUIStateMapping();
};

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleUIStateMapping = function () {
  function SimpleUIStateMapping() {
    _classCallCheck(this, SimpleUIStateMapping);
  }

  _createClass(SimpleUIStateMapping, [{
    key: "stateToRoute",
    value: function stateToRoute(uiState) {
      return uiState;
    }
  }, {
    key: "routeToState",
    value: function routeToState(routeState) {
      return routeState;
    }
  }]);

  return SimpleUIStateMapping;
}();


//////////////////
// WEBPACK FOOTER
// ../node_modules/instantsearch.js/dist-es5-module/src/lib/stateMappings/simple.js
// module id = 758
// module chunks = 20 21 22 23 24 25 26 27 28